<template>
  <div id="app">
    <SemcogHeader>
      <span class="title" style="line-height: 2em;">
        2020 Census
      </span>
    </SemcogHeader>
    <mainmap
        v-bind:mcdFilter="mcdFilter"
        v-bind:counties="counties"
        v-bind:countyid="countyid"
        v-bind:schooldistricts="schooldistricts"
        v-bind:isds="isds"
        v-bind:mappedAmenity="mappedAmenity"
        v-bind:geotype="geotype"
        v-bind:displayType="displayType"
        v-bind:printOnLoad="printOnLoad"
        v-on:countiesInput="counties = sort($event)"
        v-on:mcdInput="mcdFilter = sort($event)"
        v-on:schoolDistrictInput="schooldistricts = sort($event)"
        v-on:isdsInput="isds = sort($event)"
        v-on:input="mappedAmenity = $event"
        v-on:geotype="geotype = $event"
        v-on:countyid="countyid = $event"
        v-on:displayType="displayType = $event"
    />
  </div>
</template>

<script>
import mainmap from "./components/MainMap";
import SemcogHeader from './components/SemcogHeader.vue';
import {diff} from 'deep-diff';

export default {
  name: 'app',
  components: {
    mainmap, SemcogHeader
  },
  data: function () {
    let multiCountyCommunities = [3045, 1080, 6120, 3065, 5080, 4070, 1130, 2165]

    let qmcd = this.$route.query.mcd;
    let qcounty = parseInt(this.$route.query.county, 10);

    if (parseInt(qmcd, 10) === 3090) {
      qmcd = 8025
    }

    if (multiCountyCommunities.includes(parseInt(qmcd, 10))) {
      qmcd = 0
    }

    if (qcounty) {
      this.$route.query.geotype = 'counties'
    }
    let county = [];
    if (qcounty) {
      if (Array.isArray(qcounty)) {
        county = qcounty.map(m => {
          return {statevalue: parseInt(m, 10)}
        });
      } else {
        county = [{statevalue: parseInt(qcounty, 10)}]
      }
    }

    let qschooldistrict = this.$route.query.dcode;
    let qisd = this.$route.query.isd;
    let isd = [];
    if (qisd) {
      if (Array.isArray(qisd)) {
        isd = qisd.map(m => {
          return {statevalue: parseInt(m, 10)}
        });
      } else {
        isd = [{statevalue: parseInt(qisd, 10)}]
      }
    }

    return {
      mcdFilter: (Array.isArray(qmcd) ? qmcd.map(m => parseInt(m, 10)) : parseInt(qmcd, 10)) || 0,
      counties: county,
      countyid: qcounty || false,
      schooldistricts: (Array.isArray(qschooldistrict) ? qschooldistrict.map(m => parseInt(m, 10)) : parseInt(qschooldistrict, 10)) || 0,
      isds: isd,
      printOnLoad: this.$route.query.print,
      mappedAmenity: this.$route.query.dataset || 'pop_tot',
      geotype: this.$route.query.geotype || 'mcds',
      displayType: this.$route.query.displayType || 'percent',
    }
  },
  computed: {
    query: function () {
      let out = {};
      if (this.mcdFilter) {
        out.mcd = this.mcdFilter
      }
      if (this.countyid) {
        out.county = this.countyid
        out.geotype = 'counties'
      }
      if (this.schooldistricts) {
        out.dcode = this.schooldistricts
      }
      if (this.mappedAmenity !== 'pop_tot') {
        out.dataset = this.mappedAmenity
      }
      if (this.geotype !== 'mcds') {
        out.geotype = this.geotype
      }
      return out
    },
  },
  methods: {
    sort: function (ids) {
      if (ids.sort) {
        return ids.sort((a, b) => a - b);
      }
      return ids;
    }
  },
  watch: {
    query: function (oldVal, newVal) {
      if (diff(oldVal, newVal)) {
        this.$router.replace({
          path: "./",
          query: this.query
        })
      }
    },
    geotype: function () {
      this.mcdFilter = 0
      this.schooldistricts = 0
      this.isds = []
      this.counties = []
      this.countyid = false
    },
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-rows: max-content auto;
  font-family: Arial, Helvetica, sans-serif;
}

@media screen and (max-width: 800px) {
  #app {
    height: initial;
  }
}

@media screen {
  .title {
    display: unset;
  }
}

@media print {
  @page {
    size: landscape;
  }

  .title {
    display: none;
  }
}
</style>
